import { Column } from '~components/table-view';

const columnsFactory = (): Column[] => [
  {
    id: 'package_fixed.funding_type.name',
    header: 'Funding Type',
    type: 'text',
    deriveValue: (row) => row.package_fixed?.funding_type?.name ?? '',
  },
  {
    id: 'start_date',
    header: 'Start Date',
    type: 'date',
  },
  {
    id: 'end_date',
    header: 'End Date',
    type: 'date',
  },
];

export default columnsFactory;
